import "./da.scss";
const DALayout = ({ children }) => {
  return (
    <>
      <div className="container-main container-da">{children}</div>
    </>
  );
};

export default DALayout;
